export default __webpack_public_path__ + "static/media/okara-logo-footer_2.0acfe041.png";